import { EvergreenCommunityListingAvailability, formatCurrencyRange } from "@sp-crm/core";
import React from "react";
import { useCanRequestCommunityAvailability } from "store/selectors/hooks";
import { ListableCommunity } from "../props";
import { LayoutItemPricingExisting } from "./layout-item-pricing-existing";
import { LayoutItemPricingMissing } from "./layout-item-pricing-missing";

interface LayoutItemPricingProps {
    community: ListableCommunity;
}

export const LayoutItemPricing: React.FC<LayoutItemPricingProps> = props => {
    const { community } = props;
    const { pricing, isAvailabilityAllowed } = community;
    const requestUpdatesAllowed = useCanRequestCommunityAvailability();

    if (!isAvailabilityAllowed) {
        return null;
    }

    const hasAvailability =
        !!community.availability?.status &&
        community.availability?.status !== EvergreenCommunityListingAvailability.Unknown;

    const canRequestPricing = requestUpdatesAllowed && hasAvailability;
    const canRequestParticipation = requestUpdatesAllowed && !hasAvailability;

    let priceDisplay: string;

    if (pricing?.minPrice || pricing?.maxPrice) {
        priceDisplay = formatCurrencyRange(pricing.minPrice, pricing.maxPrice);
    }

    const hasPricingInfo = priceDisplay || pricing?.notes || pricing?.files?.length > 0;
    const showRequestPricingLink =
        !hasPricingInfo && (canRequestPricing || canRequestParticipation);

    if (!hasPricingInfo && !showRequestPricingLink) {
        return null;
    }

    return (
        <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Community pricing</dt>
            {hasPricingInfo ? (
                <LayoutItemPricingExisting
                    community={community}
                    priceDisplay={priceDisplay}
                />
            ) : (
                <LayoutItemPricingMissing
                    community={community}
                    canRequestPricing={canRequestPricing}
                    canRequestParticipation={canRequestParticipation}
                />
            )}
        </div>
    );
};
